import axios from 'axios';
import  { useEffect, useState, useMemo } from 'react';

const useGetFacultyImages = (facultyName) => {
  const [facultyImages, setFacultyImages] = useState([]);

  const getFacultyImages = async () => {
    try {
      const url = `${process.env.REACT_APP_API}/admin/faculty_images/visible`;
      const res = await axios.get(url);
      setFacultyImages(res?.data?.data || []);
    } catch (error) {
      console.error("Error fetching faculty images:", error);
    }
  };

  useEffect(() => {
    getFacultyImages();
  }, []);

  
  const filteredImages = useMemo(
    () => facultyImages.filter((f) => f.faculty === facultyName),
    [facultyImages, facultyName]
  );

  return filteredImages;
};

export default useGetFacultyImages;
